import clsx from 'clsx';
import React from 'react';
import { FieldsWithType } from '@lmt/unicorn-shared/app/helpers/typeUtils';

import styles from './OptionList.module.scss';

interface OptionListProps<D> {
  visible: boolean;
  options: D[];
  onClick: (option: D) => void;
  labelField: FieldsWithType<D, string>;
  className?: string;
  elementRef?: React.RefObject<HTMLDivElement>;
}

export function OptionList<D>(props: OptionListProps<D>) {
  const { visible, labelField, options, onClick, className, elementRef } =
    props;

  if (!visible) {
    return null;
  }
  if (options.length === 0) {
    return (
      <div
        ref={elementRef}
        className={clsx(styles.optionListContainer, className)}
        data-test-id={'icon-drop-down-option-list'}
      >
        <div className={styles.optionContainer}>
          <div className={styles.selectedValue}>{'No data'}</div>
        </div>
      </div>
    );
  }

  return (
    <div
      ref={elementRef}
      className={clsx(styles.optionListContainer, className)}
      data-test-id={'icon-drop-down-option-list'}
    >
      {options.map((option) => (
        <div
          key={`${option[labelField]}`}
          className={styles.optionContainer}
          onClick={() => onClick(option)}
          data-test-id={'icon-drop-down-option-item'}
        >
          <div
            data-color={(option as any)['color'] ?? ''}
            className={styles.selectedValue}
          >
            {option[labelField] as any}
          </div>
        </div>
      ))}
    </div>
  );
}
